export const formatCurrency = (value: number | string, currency = 'BRL'): string => {
    let numericValue = value;
    if (typeof value === 'string') {
        numericValue = parseFloat(value);
    }

    if (isNaN(numericValue as number)) return 'R$ 0,00';

    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: currency.toUpperCase(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(numericValue as number);
};

export const formatDecimal = (value: number): string => {
    return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const parseCurrency = (value: string): number => {
    const cleanValue = value.replace(/\./g, '').replace(',', '.');
    return parseFloat(cleanValue) || 0;
};

export const formatDateTime = (date: string | Date): string => {
    if (!date) return '';
    const d = new Date(date);
    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(d);
};

export const formatDate = (dateStr: string | Date | null): string => {
    if (!dateStr) return 'N/A';
    const d = new Date(dateStr);
    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(d);
};

export const formatDateLong = (dateStr: string | null): string => {
    if (!dateStr) return 'N/A';
    return new Intl.DateTimeFormat('pt-BR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(new Date(dateStr));
};


export const formatPhone = (value: string): string => {
    if (!value) return '';
    const numbers = value.replace(/\D/g, '');
    const limitedNumbers = numbers.substring(0, 11);

    if (limitedNumbers.length === 0) return '';
    if (limitedNumbers.length <= 2) return `(${limitedNumbers}`;
    if (limitedNumbers.length <= 6) return `(${limitedNumbers.substring(0, 2)}) ${limitedNumbers.substring(2)}`;
    if (limitedNumbers.length <= 10) return `(${limitedNumbers.substring(0, 2)}) ${limitedNumbers.substring(2, 6)}-${limitedNumbers.substring(6)}`;
    return `(${limitedNumbers.substring(0, 2)}) ${limitedNumbers.substring(2, 7)}-${limitedNumbers.substring(7)}`;
};

export const BRAZIL_PHONE_PREFIX = '+55 ';

/** Máscara BR: +55 fixo + (DDD) 9XXXX-XXXX — usuário digita só DDD e número. */
export const formatPhoneWithDDI = (value: string): string => {
    if (!value || value.replace(/\D/g, '').length === 0) return BRAZIL_PHONE_PREFIX;

    let numbers = value.replace(/\D/g, '');
    if (!numbers.startsWith('55')) numbers = `55${numbers}`;
    numbers = numbers.substring(0, 13);

    if (numbers.length <= 2) return BRAZIL_PHONE_PREFIX;
    if (numbers.length <= 4) return `+${numbers.substring(0, 2)} (${numbers.substring(2)}`;
    if (numbers.length <= 8) {
        return `+${numbers.substring(0, 2)} (${numbers.substring(2, 4)}) ${numbers.substring(4)}`;
    }
    if (numbers.length <= 12) {
        return `+${numbers.substring(0, 2)} (${numbers.substring(2, 4)}) ${numbers.substring(4, 8)}-${numbers.substring(8)}`;
    }
    return `+${numbers.substring(0, 2)} (${numbers.substring(2, 4)}) ${numbers.substring(4, 9)}-${numbers.substring(9)}`;
};

export const formatCardBrand = (brand: string | null): string => {
    if (!brand) return 'Cartão';
    const brands: Record<string, string> = {
        visa: 'Visa',
        mastercard: 'Mastercard',
        amex: 'American Express',
        elo: 'Elo',
        hipercard: 'Hipercard',
    };
    return brands[brand.toLowerCase()] || brand.toUpperCase();
};
export const getInitials = (name: string | null | undefined): string => {
    if (!name) return 'U';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length === 0) return 'U';
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};
